// extracted by mini-css-extract-plugin
module.exports = {"disclaimer":"CompanyDisclaimer_disclaimer__1yYzt","disclaimerLink":"CompanyDisclaimer_disclaimerLink__3u9QI"};